import { Typography } from '@mui/material';
import { FC } from 'react';

interface BodyTextProps {
    text: string;
}

export const BodyText: FC<BodyTextProps> = ({ text }) => {
    return <Typography variant="body2">{text}</Typography>;
};
